import { inject, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { legacyIssuesRedirect } from 'src/app/shared/helpers/issues-tab';

const routes: Routes = [
  {
    // The project Issues page is now the project's Issues tab
    // (/projects/:projectId?tab=issues). Old links (bookmarks, emails) land
    // there with their status / open issue / scope kept.
    path: 'project/:projectId',
    pathMatch: 'full',
    redirectTo: ({ params, queryParams }) => {
      const { commands, queryParams: qp } = legacyIssuesRedirect(params['projectId'], queryParams);
      return inject(Router).createUrlTree(commands, { queryParams: qp });
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class IssueRoutingModule {
}
